import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import UseCasesSection from '@/components/landing/use-cases-section'
import FeaturesSection from '@/components/landing/features-section'
import ExportSection from '@/components/landing/export-section'
import GoogleTvSection from '@/components/landing/google-tv-section'
import PricingSection from '@/components/landing/pricing-section'
import FaqSection from '@/components/landing/faq-section'
import DownloadSection from '@/components/landing/download-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <UseCasesSection />
            <FeaturesSection />
            <ExportSection />
            <GoogleTvSection />
            <PricingSection />
            <FaqSection />
            <DownloadSection />
        </Layout>
    )
}

export default Home
